<template>
    <div v-if="sokFacets" class="searchfacets">
      <Collapse
        :id="'searchfacets-collapse'"
        :open="!isDesktopView"
      >
        <template #button-content-before-icon>
          <text id="searchfacets-collapse-rubrik">Fler filter</text>
        </template>
        <template #collapse-content>
          <SearchFacetsFieldset
          v-for="(facets, key) in sokFacets"
            :legend="getLegend(key)"
            :facets="facets"
            :selectedList="getSelectedList(key)"
            :facetName="key"
            :texts="texts"
            @facetSelected="facetSelected"
          ></SearchFacetsFieldset>
        </template>
      </Collapse>
      <div v-if="Object.keys(selectedFacets).length > 0" class="selectedfacets">
        <SearchFacetsSelected 
        :selectedFacets="selectedFacets"
        :texts="texts"
        ></SearchFacetsSelected>
      </div>
    </div>
  </template>
  <script>
  import Collapse from "../../bootstrap/collapse.vue";
  import SearchFacetsFieldset from "./searchfacetsfieldset.vue";
  import SearchFacetsSelected from "./searchfacetsselected.vue";
  
  export default {
    name: "SearchFacets",
    props: {
      selectedFacets: Object,
      texts: Object,
      sokFacets: Object,
    },
    data: function () {
      return {
        isDesktopView: true,
        selectedList: { ...this.selectedFacets },
        breakpoint: parseInt(
          getComputedStyle(document.body).getPropertyValue("--bs-breakpoint-xl")
        ),
      };
    },
    components: {
      Collapse,
      SearchFacetsFieldset,
      SearchFacetsSelected,
    },
    created() {
      this.IsDesktop();
    },
    mounted() {
      window.addEventListener("resize", this.IsDesktop);
    },
    unmounted() {
      window.removeEventListener("resize", this.IsDesktop);
    },
    methods: {
      facetSelected(selected, facetnamn) { 
        const cleanedFacetName = facetnamn.replace('utb_tillfallen/', '');
        this.$emit("facetSelected", selected, cleanedFacetName);
      },
      getLegend(key) {
        const cleanedFacetName = key.replace('utb_tillfallen/', '');
        return this.texts[cleanedFacetName] || key; // Default to key if no specific legend is defined
      },
      getSelectedList(key) {
        const cleanedKey = key.replace("utb_tillfallen/", "");
        return this.selectedList[cleanedKey] || [];
      },
      onClick(event, selected) {
        //if (event.x != 0 || event.y != 0) {
        //  this.updateSelected(selected);
        //    this.$emit("facetSelected", this.selectedList);
       // }
      },
      IsDesktop() {
        this.isDesktopView = window.innerWidth >= this.breakpoint;
      },
    },
    watch: {
      selectedFacets: {
        deep: true,
        handler(newVal) {
          this.selectedList = { ...newVal };
        },
      },
    },
  };
  </script>
